import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { supabase } from '../supabaseClient.js';

const LogoutButton = ({ className = '', iconOnly = false }) => {   // ⬅️ default '' biar nggak 'undefined'
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;

      navigate('/login');
    } catch (error) {
      alert(t('sidebar.logoutError') + ': ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"                           // ⬅️ penting kalau nanti di dalam form
      onClick={handleLogout}
      disabled={loading}
      title={iconOnly ? t('sidebar.logout') : undefined}
      className={`
        inline-flex items-center gap-2
        ${iconOnly ? 'p-2' : 'px-3 py-2 sm:px-4 sm:py-2'}           /* sedikit lebih kecil di mobile */
        bg-white text-red-600
        border border-red-200 rounded-lg
        text-xs sm:text-sm font-semibold
        hover:bg-red-50 hover:border-red-300
        disabled:opacity-60 disabled:cursor-not-allowed
        transition-all duration-300 shadow-sm
        ${className}
      `}
    >
      {loading ? (
        <span className="animate-spin h-4 w-4 border-2 border-red-600 border-t-transparent rounded-full" />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
          className="w-5 h-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6A2.25 2.25 0 005.25 5.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
          />
        </svg>
      )}
      {!iconOnly && (loading ? t('sidebar.loggingOut') : t('sidebar.logout'))}
    </button>
  );
};

export default LogoutButton;
